export const ProjectAreaTypeEnums = {
  GROUP: { value: 'ZCLX-FYGL-XQXM-ZG', label: '组团' },
  BUILDING: { value: 'ZCLX-FYGL-XQXM-LZ', label: '楼栋' },
  UNIT: { value: 'ZCLX-FYGL-XQXM-DY', label: '单元' },
  FLOOR: { value: 'ZCLX-FYGL-XQXM-LC', label: '楼层' },
  HOUSE: { value: 'ZCLX-FYGL-FW', label: '房屋' },
  OTHER: { value: 'ZCLX-FYGL-XQXM-QTGGZY', label: '其他公共资源' }
}

export const AssetTypeEnums = {
  HOUSE: { value: 'ZCLX-FYGL-FW', label: '房屋' },
  PARK_GROUP: { value: 'group', label: '车场区域' },
  CAR_PORT: { value: 'spot', label: '车位' },
  VEHICLE: { value: 'VEHICLE', label: '车辆' }
}

export const CustomerTypeEnums = {
  OWNER: { value: 1, label: '业主' }
}

// 问卷-字段类型
export const QuestionnaireSelectType = {
  WBK: {value: 'SPACE-WJZDLX-WBK', label: '文本框'},
  DXK: {value: 'SPACE-WJZDLX-DXK', label: '单选框'},
  FXK: {value: 'SPACE-WJZDLX-FXK', label: '多选框'},
  PF: {value: 'SPACE-WJZDLX-PF', label: '评分'},
}

export const ChangeTypeEnums = {
  CANCEL: {label: '账单生成',value: 2},
  FEE_CANCEL: {label: '帐单取消',value: 20},
  FREEZE: {label: '冻结',value: 1},
  UNFREEZE: {label: '解除冻结',value: 10},
  REDUCE: {label: '减免',value: 3},
  UNREDUCE: {label: '减免撤销',value: 30},
  LATEFEE_ADD: {label: '违约金增加',value: 4},
  LATEFEE_REDUCE: {label: '违约金减免',value: 40},
  UNLATEFEE_REDUCE: {label: '违约金减免撤销',value: 41},
  CHARGE: {label: '缴费',value: 5},
  CANCEL_CHARGE: {label: '撤销缴费',value: 50},
}

export const AuditStatusEnums = {
  UNSUBMIT: {label: '未提交',value: 0},
  APPLYING: {label: '申请中',value: 1},
  APPROVE: {label: '申请通过',value: 2},
  REJECT: {label: '拒绝申请',value: 3},
}
